import { Injectable, EventEmitter } from "@angular/core";
import { environment } from 'src/environments/environment';
import { FileService } from "./file.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class ServicesLogosService {
  eventServicesLogos = new EventEmitter<any>();

  constructor(private fileService: FileService) { }

  private sanitizeServiceName(service: string): string {
    return service
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-");
  }

  getImgURL(service: string): string {
    const sanitizedService = this.sanitizeServiceName(service);
    const themeSuffix = localStorage[environment.theme] === 'dark' ? '-dark' : '';

    const fileUrl = `assets/images/services/${sanitizedService}${themeSuffix}.svg`; // Caminho para o arquivo na pasta assets

    // Retorna o Observable com o valor correto
    return fileUrl ? fileUrl : 'assets/images/services/tuna-icon.svg';
  }

  // Alteração: getLogo agora retorna uma Promise
  getLogo(service: any) {
    const defaultImage = 'assets/images/services/tuna-icon.svg';
    const logoService = service.styles_json?.logo || service.service_name || service.name || service.custom_name;

    if (logoService) {
      return this.getImgURL(logoService);
    }

    return Promise.resolve(defaultImage);
  }

  getIcon(service: any) {
    const defaultImage = 'assets/images/services/tuna-icon.svg';
    const iconService = service.styles_json?.icon;

    if (iconService) {
      return this.getImgURL(iconService);
    }
    return defaultImage;
  }
}
